const translations = {
  "en": {
    "Add new wallet and verify": "Add new wallet and verify",
    "Connect the wallet that has completed the task for verification": "Connect the wallet that has completed the task for verification",
    "Settings": "Settings",
    "The wallet binding has reached its limit. You can go to the": "The wallet binding has reached its limit. You can go to the",
    "to manage your wallet": "to manage your wallet",
    "Verify Now": "Verify Now",
    "Wallet Confirmation": "Wallet Confirmation"
  },
  "zh-tw": {
    "Add new wallet and verify": "新增錢包並驗證",
    "Connect the wallet that has completed the task for verification": "連接已完成任務的錢包以進行驗證",
    "Settings": "設定",
    "The wallet binding has reached its limit. You can go to the": "錢包綁定已達上限。你可以前往",
    "to manage your wallet": "管理你的錢包",
    "Verify Now": "立即驗證",
    "Wallet Confirmation": "錢包確認"
  }
};

export default translations;
